import React, {useEffect, useState} from "react";
import {Box, Typography} from "@mui/material";
import moment from "moment";
import momentJS from "moment-timezone";
import Marquee from "react-fast-marquee";

import meta from "../../assets/images/meta.svg";
import selection from "../../assets/images/selection.svg";
import "./marquee.css";
import {useMarketTime} from "./useMarketTime";
import {gql, useQuery} from "@apollo/client";

// const metaData = [
//   {icon: meta, title: "META", amt: "$175.23", ratio: "+$19.25 (+13.51%)"},
//   {icon: meta, title: "META", amt: "$175.23", ratio: "+$19.25 (+13.51%)"},
//   {icon: meta, title: "TSLA", amt: "$175.23", ratio: "+$19.25"},
//   {icon: meta, title: "META", amt: "$175.23", ratio: "+$19.25 (+13.51%)"},
//   {icon: meta, title: "META", amt: "$175.23", ratio: "+$19.25 (+13.51%)"},
//   {icon: meta, title: "META", amt: "$175.23", ratio: "+$19.25 (+13.51%)"},
// ];

export const GET_META_DATA = gql`
  query GET_META_DATA {
    getfinActives
  }
`;
const Marquees = () => {
  const [currentTime, setCurrentTime] = useState(moment.utc().local().format("HH:mm MMM DD"));
  const {isOpen, timeString} = useMarketTime();
  const {data} = useQuery(GET_META_DATA);
  const {getfinActives: metaData = []} = data || {};
  useEffect(() => {
    setInterval(() => {
      setCurrentTime(moment.utc().local().format("HH:mm MMM DD"));
    }, 1000 * 15);
  }, []);

  return (
    <>
      <Box
        className="marqueeMain"
        display={{xs: "block", lg: "flex"}}
        alignItems="center"
        justifyContent="space-between"
      >
        <Box className="merqueeWrap">
          <Box className="merqueeSect" display="flex" alignItems="center">
            <Marquee speed={15} gradient={false}>
              {metaData.map((meta, key) => (
                <Box className="metaSect" key={key} display="flex" alignItems="center" justifyContent="center">
                  {/* <img src={meta.icon} alt="meta" /> */}
                  <Typography variant="h5">
                    {meta.title} <span>{"$" + Number(meta.amt.slice(1)).toFixed(2)}</span>
                    <span
                      style={{marginLeft: "6px", color: meta.ratio.includes("-") ? "red" : "#1ec876"}}
                      className="metaRatio"
                    >
                      {formatRatio(meta.ratio)}
                    </span>
                  </Typography>
                </Box>
              ))}
            </Marquee>
          </Box>
        </Box>
        <Box className="timelineWrap">
          <Box className="timeLineStatus" display="flex" alignItems="center">
            <Box className="timeLine" display="flex" alignItems="center">
              <img src={selection} alt="selection" />
              <Typography variant="h6">
                <span>Market is {isOpen ? "open" : "closed"}</span> {timeString}
              </Typography>
            </Box>
            <div id="time"></div>
            <Typography className="metaDate">{moment.utc().local().format("ddd, MMM DD")}</Typography>
            <Typography>{`${currentTime} ${momentJS.tz
              .zone(momentJS.tz.guess())
              .abbr(new Date().getTimezoneOffset())}`}</Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Marquees;

function formatRatio(text) {
  let amount = Number(text.split(" ")[0]).toFixed(2) + "";
  let ratio = Number(text.split(" ")[1].replace("(", "").replace(")", "").replace("%", "")).toFixed(2);

  return `${amount > 0 ? "+" : ""}${amount} (${amount > 0 ? "+" : ""}${ratio}%)`;
}
